import Component from '../abstracts/Component';

export default class WishlistLogic extends Component {
  get SELECTORS() {
    return {
      addtowish: '.js-addremove-wishlist .icon-wishlist',
      removefromwish: '.js-addremove-wishlist .icon-wishlist-on',
      removeItem: '.js-remove-wish',
    };
  }

  get CLASSES() {
    return {
      removing: 'removing'
    };
  }

  constructor() {
    super();
    this.addtowish = $(this.SELECTORS.addtowish);
    this.removefromwish = $(this.SELECTORS.removefromwish);
    this.removeItem = $(this.SELECTORS.removeItem);
  }

  removeProduct(el) {
    let ctx = this;
    let $elem = $(el);
    let code = $elem.data('code');

    $.ajax({
      url: $elem.data('href'),
      dataType: "json",
      type: 'POST',
      success: function (resp) {

        let item = $(`div[data-code="${code}"]`);
        item.addClass(ctx.CLASSES.removing);

        setTimeout(function () {
          item.remove()
        }, 800);
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, resp);
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  bindEvents() {

    let ctx = this;

    this.$on('click.wishlist', this.addToWishlist, 'body', this.SELECTORS.addtowish, this);

    this.$on('click.wishlist', this.removeToWishlist, 'body', this.SELECTORS.removefromwish, this);

    $('body').on('click.js-remove-wish', ctx.SELECTORS.removeItem, function (e) {
      e.preventDefault();
      e.stopPropagation();
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, this)
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, (e) => {
      this.removeProduct(e.payload);
    });
  }

  addToWishlist(e) {
    const ctx = e.event.data;
    e.event.preventDefault();
    e.event.stopPropagation();
    let $this = $(e.event.currentTarget);
    let prodCode = $this.data('code');

    ctx
      .$doAjax({
        dataType: 'html',
        url: $this.attr('href'),
        data: {
          code: prodCode
        },
      })
      .done(count => {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, {count: count, elem: $this}, $this);
      })
      .fail(xhr => {
        ctx.log('error in add/remove to wishlist');
        ctx.log(xhr);
      })
      .always(() => {

      });
  }

  removeToWishlist(e) {
    const ctx = e.event.data;
    e.event.preventDefault();
    e.event.stopPropagation();
    let $this = $(e.event.currentTarget);

    ctx
      .$doAjax({
        type: 'POST',
        dataType: 'json',
        url: $this.attr('href'),
      })
      .done(data => {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, {count: data.count, elem: $this}, $this);
      })
      .fail(xhr => {
        ctx.log('error in add/remove to wishlist');
        ctx.log(xhr);
      })
      .always(() => {

      });
  }

  render() {
    this.log('Load logics...');
    this.bindEvents();
  }
}
